<template>
    <div class="form-group" :class="{'has-error': error }">
        <label :for="$attrs.name" class="label">{{ fieldLabel }}</label>
        <div class="field-group">
            <div class="flex items-center">
                <div class="w-1/2">
                    <vSelect
                        v-model="selected"
                        label="name"
                        key="id"
                        :options="customers"
                        @input="selectedCustomer"
                        @change="selectedCustomer"
                    >
                        <template slot="option" slot-scope="option">
                            <div class="flex justify-start">
                                <div class="flex mr-4">
                                    <Icon name="plus-circle" />
                                </div>
                                <div class="flex flex-col">
                                    <strong>{{ option.name }}</strong>
                                    <template v-if="option.country">
                                        {{ option.country.name }}
                                    </template>
                                </div>
                            </div>
                        </template>
                    </vSelect>
                </div>
                <button type="button" class="flex items-center ml-4" @click="shouldShowCreateCustomerModal = true">
                    <Icon name="plus-circle" class="mr-1" /> Nieuwe klant aanmaken
                </button>
            </div>
            <input v-if="selected" type="hidden" :name="$attrs.name" :value="selected.id">
            <p class="error" v-if="error">{{ error }}</p>
            <p class="text-sm text-green-700" v-if="isCreated">Customer is created</p>
        </div>

        <portal v-if="shouldShowCreateCustomerModal" to="destination">
            <CreateCustomerModal
                @add="addCustomer"
                @close="closeCreateCustomerModal"
            />
        </portal>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import vSelect from 'vue-select';

    import CreateCustomerModal from '../modals/CreateCustomerModal';

    export default {
        name: 'CustomerInput',
        components: {
            CreateCustomerModal,
            vSelect,
        },
        inheritAttrs: false,
        props: {
            fieldLabel: {
                required: true,
                type: String,
            },
            error: {
                required: false,
                type: String,
                default: null,
            },
            preSelected: {
                type: Number,
                required: false,
                default: null,
            },
        },
        data() {
            return {
                isFocused: false,
                shouldShowCreateCustomerModal: false,
                isCreated: false,
                selected: null,
            };
        },
        created() {
            this.$store.dispatch('customers/find');
            this.selected = this.$store.state.customers.all.find(item => item.id === this.preSelected);
        },
        computed: {
            ...mapState({
                customers: state => state.customers.all,
            }),
        },
        methods: {
            addCustomer(customer) {
                this.shouldShowCreateCustomerModal = false;

                setTimeout(() => {
                    this.selected = customer;
                    this.isCreated = true;
                }, 0);
            },

            closeCreateCustomerModal() {
                this.shouldShowCreateCustomerModal = false;
            },

            selectedCustomer(customer) {
                this.$emit('selected', customer);
            },
        },
        watch: {
            customers: {
                immediate: true,
                handler(value) {
                    this.selected = value.find(item => item.id === parseFloat(this.preSelected));
                },
            },

            selected(val) {
                this.$emit('input', val.id);
            },
        },
    };
</script>
